import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  text: "WellAd has completely transformed how we handle customer calls. We've seen a 40% increase in booked appointments since implementation.",
  author: 'Sarah Johnson',
  role: 'Medical Practice Manager, Brisbane',
  initials: 'SJ'
}, {
  text: "As a small business, we couldn't afford a full-time receptionist. WellAd gives us professional call handling at a fraction of the cost.",
  author: 'Michael Roberts',
  role: 'Owner, Construction Company',
  initials: 'MR'
}, {
  text: "The lead qualification feature alone has paid for the service. We're closing more deals with less effort on our part.",
  author: 'Emily Davis',
  role: 'Sales Director, Tech Startup',
  initials: 'ED'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-16 md:py-24 lg:py-32 bg-white" data-id="element-179">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-181">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3 md:mb-4" data-id="element-182">
            What Our Clients Say
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-183">
            Businesses across Australia are transforming their customer service
            with WellAd
          </p>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-184">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className="bg-gradient-to-br from-gray-50 to-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all border border-gray-100" data-id="element-185">
              <div className="text-4xl md:text-6xl text-indigo-200 mb-3 md:mb-4" data-id="element-186">
                "
              </div>
              <p className="text-sm md:text-base text-gray-700 mb-4 md:mb-6 leading-relaxed italic" data-id="element-187">
                {testimonial.text}
              </p>
              <div className="flex items-center" data-id="element-188">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-indigo-500 to-sky-500 rounded-full flex items-center justify-center text-white font-bold mr-3 md:mr-4 text-sm md:text-base" data-id="element-189">
                  {testimonial.initials}
                </div>
                <div data-id="element-190">
                  <div className="font-bold text-black text-sm md:text-base" data-id="element-191">
                    {testimonial.author}
                  </div>
                  <div className="text-xs md:text-sm text-gray-600" data-id="element-192">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}